import { render, staticRenderFns } from "./OccurrenceEquipmentPanel.vue?vue&type=template&id=965fb344&scoped=true&"
import script from "./OccurrenceEquipmentPanel.vue?vue&type=script&lang=js&"
export * from "./OccurrenceEquipmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceEquipmentPanel.vue?vue&type=style&index=0&id=965fb344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fb344",
  null
  
)

export default component.exports